#!/usr/bin/env node

import { StdioServerTransport } from "@modelcontextprotocol/sdk/server/stdio.js";
import { initSentry } from "./api/sentry.js";
import { captureException } from "./common/errors.js";
import { useStderrOnly } from "./common/logger.js";
import { runRemoteProxy } from "./local/remote-proxy.js";

useStderrOnly();

/**
 *  Start server on STDIO
 */
async function main() {
  const disableTelemetry = process.env["ZEROHEIGHT_MCP_DISABLE_TELEMETRY"];
  if (!disableTelemetry) {
    initSentry();
  }

  if (process.env["NODE_ENV"] === "dev") {
    process.env["NODE_TLS_REJECT_UNAUTHORIZED"] = "0";
  }

  await runRemoteProxy({ stdinTransport: new StdioServerTransport() });
}

main().catch((error) => {
  console.error("Fatal error in main():", error);
  captureException(error);
  process.exit(1);
});
